export const masterDataKeyList: string[] = [
  "mr_product_group_id",
  "mr_product_style_id",
  "mr_product_colour_id",
  "mr_product_category_id",
  "mr_product_material_id",
  "main_size_id",
  "mr_category_customer_id"
]